<template>
	<div class="flex wizard-loader" :class="`step-${step}`">
		<div class="progress-line" :style="{ width: progress + '%' }" />
	</div>
</template>

<script>
export default {
	name: 'Loader',
	props: {
		step: {
			type: Number,
			default: 1
		},
		totalSteps: {
			type: Number,
			default: 11
		}
	},
	computed: {
		progress () {
			return (100 * this.step) / this.totalSteps
		},
		progressStyle () {
			return { width: `${this.progress}%` }
		}
	}
}
</script>

<style lang="scss">
	.wizard-loader {
		width: 100%;
		height: 8px;
		background: #C8CEC9;
		border-radius: 100px;
		.progress-line {
			background: #009BC9;
			border-radius: 135px;
			transition: 1s linear;
		}
	}
</style>
